import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss']
})
export class HelpMenuComponent {
  @Input() isMatCoordinator: boolean = false;

  showHelpModal: boolean = false;

  serviceNowLink: string = environment.help.serviceNowLink;
  adminName: string = environment.help.adminName;
  adminEmail: string = environment.help.adminEmail;

  onHelpClick(): void {
    if (this.isMatCoordinator) {
      window.open(this.serviceNowLink, '_blank');
    } else {
      this.showHelpModal = true;
    }
  }

  closeHelpModal(): void {
    this.showHelpModal = false;
  }
}
